import styles from './HeaderTabs.module.less'
import { Tabs, TabsProps } from 'antd/lib'
import { HeaderTabBar } from './HeaderTabBar'
import { useMemo, useState } from 'react'

export const HeaderTabs = ({ items, defaultActiveKey, onChange, ...props }: TabsProps) => {
    const [activeTabKey, setActiveTabKey] = useState(defaultActiveKey ?? items?.[0].key)

    const handleTabClick = (key: string) => {
        setActiveTabKey(key)
        onChange?.(key)
    }

    const tabMenuItems: TabsProps['items'] = useMemo(
        () => items?.map(item => ({ key: item.key, label: item.key, children: item.children })),
        [items]
    )

    return (
        <Tabs
            {...props}
            activeKey={activeTabKey}
            className={styles['header-tabs']}
            renderTabBar={() => (
                <HeaderTabBar activeKey={activeTabKey} items={items} onTabClick={handleTabClick} />
            )}
            items={tabMenuItems}
        />
    )
}
